import { render } from "./LayerScene.vue?vue&type=template&id=2ed64a2c&scoped=true"
import script from "./LayerScene.vue?vue&type=script&lang=js"
export * from "./LayerScene.vue?vue&type=script&lang=js"

import "./LayerScene.vue?vue&type=style&index=0&id=2ed64a2c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ed64a2c"]])

export default __exports__